var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLiCrAccepted = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "campaign",
    transform: "translate(-670.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 24,
    height: 24,
    transform: "translate(670.97)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "person_add_20dp_FILL0_wght300_GRAD-25_opsz20",
    d: "M138.133-726.521h-1.4a.548.548,0,0,1-.4-.169.55.55,0,0,1-.167-.4.566.566,0,0,1,.167-.405.541.541,0,0,1,.4-.174h1.4v-1.4a.556.556,0,0,1,.166-.4.54.54,0,0,1,.4-.169.564.564,0,0,1,.409.169.545.545,0,0,1,.173.4v1.4h1.4a.557.557,0,0,1,.407.168.544.544,0,0,1,.169.4.564.564,0,0,1-.169.408.549.549,0,0,1-.407.173h-1.4v1.4a.558.558,0,0,1-.168.407.548.548,0,0,1-.4.169.557.557,0,0,1-.406-.169.554.554,0,0,1-.17-.407Zm-7.811.845a2.774,2.774,0,0,1-2.04-.832,2.774,2.774,0,0,1-.832-2.04,2.774,2.774,0,0,1,.832-2.04,2.774,2.774,0,0,1,2.04-.832,2.774,2.774,0,0,1,2.04.832,2.774,2.774,0,0,1,.832,2.04,2.774,2.774,0,0,1-.832,2.04A2.774,2.774,0,0,1,130.322-725.676Zm-6.242,5.089v-.369a1.705,1.705,0,0,1,.247-.9,1.921,1.921,0,0,1,.71-.674,11.681,11.681,0,0,1,2.575-1.081,9.874,9.874,0,0,1,2.71-.38,9.883,9.883,0,0,1,2.711.38,11.627,11.627,0,0,1,2.575,1.081,1.919,1.919,0,0,1,.71.674,1.706,1.706,0,0,1,.246.9v.369a1.125,1.125,0,0,1-.34.827,1.126,1.126,0,0,1-.827.34H125.24a1.114,1.114,0,0,1-.824-.34A1.131,1.131,0,0,1,124.08-720.587Zm1.148.018h10.188v-.385a.606.606,0,0,0-.109-.349.89.89,0,0,0-.309-.272,10.021,10.021,0,0,0-2.252-.934,8.966,8.966,0,0,0-2.424-.332,8.952,8.952,0,0,0-2.428.332,9.925,9.925,0,0,0-2.243.934.881.881,0,0,0-.313.273.607.607,0,0,0-.109.347Zm5.1-6.256a1.648,1.648,0,0,0,1.216-.508,1.674,1.674,0,0,0,.5-1.221,1.648,1.648,0,0,0-.508-1.216,1.674,1.674,0,0,0-1.221-.5,1.648,1.648,0,0,0-1.216.508,1.673,1.673,0,0,0-.5,1.221,1.648,1.648,0,0,0,.508,1.216A1.673,1.673,0,0,0,130.327-726.824ZM130.322-728.572ZM130.322-720.568Z",
    transform: "translate(550.303 737.42)",
    fill: "#8d8d8d"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLiCrAccepted, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/liCrAccepted.473594d4.svg";
export { ForwardRef as ReactComponent };